// Thèmes pour les tâches / événements « internes » (organisationnels, non commerciaux).
// Utilisé quand l'item n'est PAS lié à un dossier.
export const INTERNAL_THEMES = [
    'Réunion interne',
    "Point d'équipe",
    'Formation',
    'Administratif',
    'Déplacement/Visite',
    'Recrutement',
    'Personnel',
    'Autre',
];
